import { Injectable, inject } from '@angular/core';
import type { SnackbarInput, SnackbarMessage } from '../models/snackbar-message.model';
import { SnackbarStore } from '../stores/snackbar.store';

@Injectable({
  providedIn: 'root',
})
export class SnackbarService {
  private readonly store = inject(SnackbarStore);

  show(input: SnackbarInput): SnackbarMessage {
    return this.store.enqueue(input);
  }

  dismiss(id: string): void {
    this.store.dismiss(id);
  }

  clear(): void {
    this.store.clear();
  }
}
